import React from 'react'
//layout
import MainLayout from './layout/mainLayout'




const Root=()=>{
    


    
    return(
        <MainLayout />
    )
}



export default Root